export const systemConstants = {
    RENEW_NOTIFICATION_REQUEST: 'RENEW_NOTIFICATION_REQUEST',
    RENEW_NOTIFICATION_SUCCESS: 'RENEW_NOTIFICATION_SUCCESS',
    RENEW_NOTIFICATION_FAILURE: 'RENEW_NOTIFICATION_FAILURE',

    TERMS_RENEWED_REQUEST: 'TERMS_RENEWED_REQUEST',
    TERMS_RENEWED_SUCCESS: 'TERMS_RENEWED_SUCCESS',
    TERMS_RENEWED_FAILURE: 'TERMS_RENEWED_FAILURE',
};

